import utils from './utils';

const canvas = document.querySelector('canvas');
const c = canvas.getContext('2d');

addEventListener('resize', () => {
  init();
});

class BoundaryLayer {

  #y;
  #heightPercent;
  #lineWidth;
  #strokeStyle;

  constructor(heightPercent, lineWidth, strokeStyle) {
    this.heightPercent = heightPercent;
    this.#lineWidth = lineWidth;
    this.#strokeStyle = strokeStyle;
  }

  get y() {
    return this.#y;
  }

  get heightPercent() {
    return this.#heightPercent;
  }

  set heightPercent(input) {
    if (input <= 100 && input >= 0) {
      this.#heightPercent = input;
      this.#y = canvas.height - ((input / 100) * (canvas.height - this.#lineWidth));
    }
    else {
      console.warn('Cannot set BoundaryLayer to heightPercent: ' + input + '. Must be in range 0-100.');
    }
  }

  get lineWidth() {
    return this.#lineWidth;
  }

  draw() {
    c.lineWidth = this.#lineWidth;
    c.strokeStyle = this.#strokeStyle;
    c.beginPath();
    c.moveTo(0, this.#y);
    c.lineTo(canvas.width, this.#y);
    c.closePath();
    c.stroke();
    c.textAlign = 'center';
    c.textBaseline = 'middle';
    c.font = '16px OpenSans, sans-serif';
    c.fillText('Height of Atmospheric Boundary Layer', canvas.width / 2, this.#y);
  }

  update() {
    this.draw();
  }
}

class Particle {

  #x;
  #y;
  #vx;
  #vy;
  #radius;
  #lineWidth;
  #strokeStyle;
  #delete;

  constructor(x, y, vx, vy, radius, lineWidth, strokeStyle) {
    this.#x = x;
    this.#y = y;
    this.#vx = vx;
    this.#vy = vy;
    this.#radius = radius;
    this.#lineWidth = lineWidth;
    this.#strokeStyle = strokeStyle;
    this.#delete = false;
  }

  move() {

    // Detect collision with canvas border and boundary layer and reverse
    // velocities. Padding is added to the bounding box on the x axis to prevent
    // particles from bouncing off of the visible edges. Padding is subtracted
    // from the bottom y axis bounding box.
    const xPadding = canvas.width * .0625;
    const yBottomPadding = -(canvas.width * .0625);

    let xmin = 0 + this.#radius - xPadding;
    let xmax = canvas.width - this.#radius;
    let ymin = boundaryLayer.y + (boundaryLayer.lineWidth / 2) + this.#radius;
    let ymax = canvas.height - this.#radius + yBottomPadding - 30;

    // Canvas edges collision detection and velocity reversal. If particles is
    // colliding with the right edge of the canvas, set it for deletion.
    if (this.#x <= xmin) this.#vx *= -1;
    if (this.#x >= xmax) this.#delete = true;
    if (this.#y <= ymin) {
      this.#vy *= -1;
      this.#y = ymin;
    }
    if (this.#y >= ymax) this.#vy *= -1;

    // Acceleration/Deviation
    let maxVelocity = 2 * boundaryLayer.heightPercent / 100;
    let vxDeltaMax = .1;
    let vxDeltaMin = -.1;
    let vyDeltaMax = .1;
    let vyDeltaMin = -.1;
    if (this.#vx >= maxVelocity) vxDeltaMax = 0;
    if (this.#vx <= -maxVelocity) vxDeltaMin = 0;
    if (this.#vy >= maxVelocity) vyDeltaMax = 0;
    if (this.#vy <= -maxVelocity) vyDeltaMin = 0;
    this.#vx += utils.randomFloatFromRange(vxDeltaMin, vxDeltaMax);
    this.#vy += utils.randomFloatFromRange(vyDeltaMin, vyDeltaMax);

    //Apply higher level wind.
    if (this.#y < (canvas.height * .25)) {
      this.#vx += .1;
    }
    else if (this.#y < (canvas.height * .5)) {
      this.#vx += .05;
    }

    // Set new position.
    this.#x = this.#x + this.#vx;
    this.#y = this.#y + this.#vy;
  }

  draw() {
    let circle = new Path2D();
    circle.arc(this.#x, this.#y, this.#radius, 0, 2 * Math.PI);
    c.lineWidth = this.#lineWidth;
    c.strokeStyle = this.#strokeStyle;
    c.stroke(circle);
  }

  get delete() {
    return this.#delete;
  }

}

// Implementation
let boundaryLayer;
let particles = [];
let timestamp = Math.trunc(new Date().getTime() / 150);

function init() {
  canvas.width = Math.min(innerWidth, 800);
  canvas.height = canvas.width * .75;
  document.getElementById('ui').style.marginTop = canvas.height - 40 + 'px';
  console.log(canvas.width);
  console.log(canvas.width / 800);

  boundaryLayer = new BoundaryLayer(document.getElementById('boundaryLayerHeight').value, 30, 'rgba(255, 255, 255, 0.7)');
  boundaryLayer.draw();
}

// Animation Loop
function animate() {
  requestAnimationFrame(animate);
  c.clearRect(0, 0, canvas.width, canvas.height);

  boundaryLayer.heightPercent = parseInt(document.getElementById('boundaryLayerHeight').value);
  boundaryLayer.update();

  // Move all particles.
  for (let i = 0; i < particles.length; i++) {
    particles[i].move();

    if (particles[i].delete == true) {
      particles.splice(i--, 1);
    }
    else {
      particles[i].draw();
    }
  }

  // Point source add/remove particles.
  let seconds = Math.trunc(new Date().getTime() / 150);
  if (seconds > timestamp) {
    timestamp = seconds;
    let particle = new Particle(
      canvas.width * .52625,
      (canvas.height - 30) * .74,
      0,
      -2 * boundaryLayer.heightPercent/100, // The higher the boundary the faster the y velocity.
      utils.randomIntFromRange(1, 3),
      2,
      'rgba(0, 0, 0, 0.7)'
    );
    if (particles.length >= 100) {
      particles.shift();
    }
    particles.push(particle);
  }

}

init();
animate();
